<template>
  <div class="vendor-trends-item-wrapper">
     <preloader :preloaderStatus="!loaded" ></preloader>

    <div class="dashboards-filters vendor-kpi-filters">
      <h4>{{ title }}</h4>

      <div class="dashboards-filters-item dashboards-filters-date date-simple">
        <date-picker
          v-model="params.creation_date"
          format="D MMM"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
        ></date-picker>
      </div>

      <div class="dashboards-filters-item">
        <filter-multiselect
          v-model="params.lsp"
          :options="lspList"
          field-name="Name"
          placeholder="LSP"
          :multiple="false"
          required
        />
      </div>

      <div class="dashboards-filters-item">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters-item">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters-item">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters-item">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters-item">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters-item">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
    <template>
      <chart-constructor
      @loaded="loaded = true"
      :options="chartOptions"
      />
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import props from './props';

export default Vue.extend({
  name: 'VendorTrendsMainItem',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'chart-constructor': () =>
      import('@/components/charts/chartConstructor/index.js'),
    'preloader': () => import('@/components/preloader'),
  },
  props: {
    ...props,
  },
  data: () => ({
    chartOptions: Object(),
    loaded: false,
  }),
  watch: {
    value: {
      handler() {
        this.redrawGraph();
      },
      deep: true,
    },
  },
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    ajaxParams() {
      return {
        LspId: this.params.lsp.ID || '',
        SourceLang: this.params.sourceLanguage && this.params.sourceLanguage.ID
          ? [this.params.sourceLanguage.ID] : null,
        TargetLang: this.params.targetLanguage && this.params.targetLanguage.ID
          ? [this.params.targetLanguage.ID] : null,
        IndustrySectors: this.params.industry_field.map((el) => el.ID),
        DocumentTypes: this.params.doc_type.map((el) => el.ID),
        QaModelIds: this.params.qaModel.map((el) => el.ID),
        EvMethodIds: this.params.qaMethod.map((el) => el.ID),
      };
    },
  },
  methods: {
    genOptionsObject(series) {
      const categories = series.map((e) => e.name);
      return {
        chart: {
          type: 'column',
          height: 200,
        },
        title: {
          text: '',
        },
        xAxis: {
          opposite: true,
          categories,
        },
        yAxis: {
          visible: false,
        },
        plotOptions: {
          column: {
            color: '#434348',
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              formatter: function() {
                return this.point.data;
              },
              verticalAlign: 'center',
              style: {
                fontSize: '60px',
              },
            },
          },
        },
        tooltip: {
          formatter: function() {
            return `${this.x}: <b>${this.point.data}</b>`;
          },
        },
        legend: {
          enabled: false,
        },
        series,
      };
    },
    redrawGraph() {
      if (this.value.lsp) {
        this.getData().then((series) => {
          this.chartOptions = this.genOptionsObject(series);
        });
      } else {
        this.chartOptions = this.genOptionsObject(Array());
      }
    },
    // Impementing this methods in child components
    getData() {
      return new Promise((res) => {
        res(Array());
      });
    },
  },
  mounted() {
    this.redrawGraph();
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  background: #fff;
  margin-bottom: 50px;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto;

  &-date {
    margin-left: 40px;
  }
}
.vendor-kpi-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto!important;

}
</style>
